import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {ErrorService} from '../../error/error.service';

@Injectable({
    providedIn: 'root'
})
export class LicenseTextResolver implements Resolve<string> {

    constructor(private readonly httpClient: HttpClient, private readonly errorService: ErrorService) {
    }

    public resolve(): Observable<string> {
        return this.httpClient.get('./assets/NOTICE.txt', {responseType: 'text'}).pipe(
            catchError((error: HttpErrorResponse) => {
                this.errorService.navigateToErrorPage(error);
                return of(null);
            }));
    }
}
